import React from 'react'

const AuditLogs = () => {
  return (
    <div>AuditLogs</div>
  )
}

export default AuditLogs;